const $ = require('jquery');
const navigation = {
  navigationsId: ['advancedDesktopNavigation', 'advancedMobileNavigation'],
  isNewNavigation: false,
  mobileClassName: 'advancedMobileNavigation',

  init: function() {
    this.isNewNavigation = !!document.querySelectorAll('.newAdvancedDesktopNavigation, .newAdvancedMobileNavigation').length
    this.mobileClassName = this.isNewNavigation ? 'newAdvancedMobileNavigation' : 'advancedMobileNavigation'
    this.whiteOnScroll(this.navigationsId);
    this.events();
    this.dropDown();
    this.mobileMenu.init();
    this.videoModal();
    this.updateAuthUrls();
    this.changePositions(this.navigationsId);
    this.handlePricingLinks();
  },

  handlePricingLinks: function () {
    const targets = document.querySelectorAll('[data-handle-pricing]'),
      pricingBlock = document.querySelector('[data-main-pricing]');

    if (targets.length > 0) {
      targets.forEach(t => {
        t.addEventListener('click', (e) => {
          e.preventDefault();
          if (!pricingBlock) {
            customModal.init('js-modalPricing');
            customModal.view(true);
          } else {
            if (window.innerWidth < 1200) {
              this.mobileMenu.switch(document.querySelector(`.${this.mobileClassName}-controll`));
            }
            window.scrollTo({ top: pricingBlock.offsetTop-90, behavior: 'smooth'});
          }
        });
      });
    }
  },

  updateAuthUrls: function() {
    if (localStorage.getItem('emailCollect') !== null) {
      Array.prototype.slice.call(document.querySelectorAll('[data-authlink]')).forEach(e => {
        e.href = e.dataset.authlink;
      });
      Array.prototype.slice.call(document.querySelectorAll('[data-authtarge]')).forEach(e => {
        e.target = e.dataset.authtarge;
      });
    }
  },

  videoModal: function() {
    const links = Array.prototype.slice.call(document.getElementsByClassName('advancedNavigation__videmodal'));
    const nav = document.querySelector('header');
    const check = (target) => {
      if (target.classList.contains('advancedNavigation__videmodal')) {
        return true;
      }
    }
    if (links.length > 0 && nav) {
      nav.addEventListener("click", (e) => {
        check(e.target.parentElement) && updateModal(e.target.parentElement);
        check(e.target) && updateModal(e.target);
        check(e.target.parentElement.parentElement) && updateModal(e.target.parentElement.parentElement);
      });
    }
    const updateModal = (target) => {
      document.getElementById('link').src = target.dataset.href;
    }
  },

  toggleClass: function(target, cond, className) {
    const e = typeof target === 'string' ? document.getElementById(target) : target;
    const condition = typeof cond === 'string' ? !e.classList.contains(cond) : cond;
    if (condition) {
      e.classList.add(className);
    } else {
      e.classList.remove(className);
    }
  },

  whiteOnScroll: function(targets) {
    targets.forEach(e => {
      this.toggleClass(e, $(window).scrollTop() >= 60, 'whiteOnScroll');
    });
  },

  whiteOnDrop: function(target, status) {
    this.toggleClass(target, status, 'whiteOnDrop');
  },

  changePositions: function(targets) {
    const scrollPosition = window.scrollY;
    targets.forEach(e => {
      document.getElementById(e).style.position = window.scrollY >= 40 ? 'fixed' : 'relative';
    });
  },

  mobileMenu: {
    init: function() {
      this.isNewNavigation = !!document.querySelectorAll('.newAdvancedDesktopNavigation, .newAdvancedMobileNavigation').length
      this.mobileClassName = this.isNewNavigation ? 'newAdvancedMobileNavigation' : 'advancedMobileNavigation'
      this.events();
      this.mobileDropDown();
    },
    target: document.getElementById('advancedMobileNavigation'),
    position: 0,
    events: function() {
      this.target.addEventListener('click', (e) => {
        const target = e.target.parentNode;
        if (target.classList.contains(`${this.mobileClassName}-controll`)) {
          this.switch(target);
        }
      });
    },
    switch: function(target) {
      const btnCondition = !target.classList.contains('open');
      this.saveScrollPosition(btnCondition);
      navigation.toggleClass(target, btnCondition, 'open');
      navigation.toggleClass('advancedMobileNavigation-dropdown', 'open', 'open');
      navigation.whiteOnDrop('advancedMobileNavigation', btnCondition);
      btnCondition && this.resetMobileDropMenu(null);
    },

    saveScrollPosition: function(condition) {
      const displayBody = () => document.getElementsByTagName('body')[0].classList.toggle('open');
      if (condition) {
        this.position = window.scrollY;
        displayBody();
      } else {
        displayBody();
        window.scroll(0, this.position);
      }
    },

    mobileDropDown: function() {
      document.querySelectorAll(`.${this.mobileClassName}__menu`).forEach(el => {
        el.addEventListener("click", function(e) {
          navigation.mobileDisplayDrop(e.target);
        });
      });
    },

    resetMobileDropMenu: function(current) {
      Array.prototype.slice.call(document.getElementsByClassName(`${this.mobileClassName}__menu`)).forEach(e => {
        if (e !== current) {
          e.children[e.children.length - 1].style.display = 'none';
          e.classList.remove('open');
        }
      });
    }

  },

  dropDown: function(e) {
    document.querySelectorAll('.advancedDesktopNavigation__menu, .newAdvancedDesktopNavigation__menu').forEach(el => {
      el.addEventListener("mouseenter", function(e) {
        navigation.displayDrop(e.target, true);
        navigation.whiteOnDrop('advancedDesktopNavigation', true);
      });
      el.addEventListener("mouseleave", function(e) {
        !localStorage.getItem('freezeNavigation') && navigation.displayDrop(e.target, false);
        navigation.whiteOnDrop('advancedDesktopNavigation', false);
      });
    });

  },

  mobileDisplayDrop: function(e) {
    const className = `${this.mobileClassName}__menu`;
    const parent = e.parentElement;
    const check = (target) => {
      if (target.classList.contains(className)) {
        return true;
      }
    }
    const open = (e) => {
      e.classList.toggle('open');
      const children = e.children;
      const drop = children[children.length - 1];
      if (drop.tagName === 'DIV') {
        drop.style.display = drop.style.display === "block" ? 'none' : 'block';
      } else {
        log('Dropdown undefinded');
      }
      this.mobileMenu.resetMobileDropMenu(e);
    }

    if (check(e)) {
      open(e)
    } else if (check(parent)) {
      open(parent)
    }
  },

  displayDrop: function(e, status) {
    const children = e.children;
    const drop = children[children.length - 1];

    if (drop.tagName === 'DIV') {
      drop.style.display = status ? 'block' : 'none';
    } else {
      log('Dropdown undefinded');
    }
  },

  events: function() {
    document.addEventListener("scroll", () => {
      this.whiteOnScroll(this.navigationsId);
      this.changePositions(this.navigationsId);
    });
  }
}

module.exports = navigation;


